/* eslint-disable @typescript-eslint/naming-convention */
export interface ColumnModel {
	table_name: string; //:"DRILL_HOLE_DIRECTION",
	table_id: number; //:12,
	column_name: string; //:"Uncorrected_Azimuth",
	column_label: string; //:"Uncorrected Azimuth",
	data_type: string; //:"NUMERIC",
	width?: number; //:10,
	default_value?: string;
	decimal_places?: number; //:2,
	minimum_value?: number;
	maximum_value?: number;
	display_order?: number; //:8,
	// eslint-disable-next-line max-len
	calculation_formula?: string; //:"IIF({azimuth_decimal}-{Corrected_Azi_Factor}<0, ({azimuth_decimal}+360)-{Corrected_Azi_Factor}, {azimuth_decimal}-{Corrected_Azi_Factor})",
	is_column_nullable?: string; //:"Y",
	inherit_values?: string; //:"N",
	display_column?: string; //:"Y",
	is_editable?: string; //:"Y",
	column_style?: number; //:0,
	code_table_name?: string; //:"",
	code_display_column_name?: string; //:"",
	code_data_column_name?: string; //:""},
	edit_style?: string;
	is_minor?: string;
	table_module?: string;
	pk_composed?: string;
	depth_from?: number;
	depth_to?: number;
	inherit_values_column?: string;
	report_preview?: string;
}
